export default {
  '--text': '#111827',
  '--white': '#ffffff',
  '--black': '#000000',
  '--primary': '#8c2fdf',
  '--secondary': '#fbbf24',
  '--background': '#ffffff',
  '--brand-green': '#50B55D',
  '--brand-green-dark': '#117D2D',
  '--brand-green-light': '#CBF0E0',
  '--brand-green-light-dark': '#50B55D',
  '--cream': '#FFFCF5',
  '--yellow-dark': '#A17805',
}
